import React, { FC } from 'react'
import { sanitizeHTML } from '../../../../../utils/common-utils'
import { BrandIcon } from '../../../../Compounds/src/BrandIconCompound'
import { OneColumnBannerProps } from './OneColumnBanner.types'
import { getBgThemeBasedOnColor, getValueListBgColor } from '../../../../../utils/background-util'

export const OneColumnBanner: FC<OneColumnBannerProps> = props => {
  const { content } = props

  const {
    contentDesc,
    bgImage,
    bgColor,
    link,
    textAlignment,
    icon,
    verticalSpacing,
    brandExtension,
  } = content

  const hasFacet = bgColor?.includes('facet')
  const facet = hasFacet ? `url(${bgColor})` : ''

  const theme = getBgThemeBasedOnColor(bgColor as string)

  return (
    <div className={`one-column-layout ${brandExtension}`}>
      <section
        className={`u-flex u-flexCol u-sizeFill u-flexJustifyCenter ${verticalSpacing} ${
          !hasFacet && getValueListBgColor(bgColor as string)
        } ${bgImage ? 'Banner--primary u-bgSizeCover' : 'Banner--secondary'}`}
        style={{
          backgroundImage: bgImage ? `url(${bgImage})` : facet,
        }}>
        <div className='Content u-sizeConstrained u-paddingVert12gu'>
          <div
            className={`u-md-size10of12 u-sm-paddingHoriz3gu Content ${textAlignment} ${
              bgColor && theme === 'Dark' ? 'Content--reversed' : ''
            }`}>
            <div className={`${textAlignment} Content`}>
              {icon && (
                <BrandIcon
                  iconsDropdown={icon.iconsDropdown}
                  iconsColorsDropdown={
                    theme === 'Dark' ? 'u-fillColorData2' : 'u-fillColorDarkMint'
                  }
                  alignment={icon.alignment ?? 'center'}
                  size={icon.size}
                  identifier={icon.identifier}
                  stylesDropdown={icon.stylesDropdown}
                />
              )}
              <div
                className='u-marginBottom4gu'
                dangerouslySetInnerHTML={{
                  __html: sanitizeHTML(contentDesc ?? ''),
                }}></div>
              {link?.map((currLink, index) => {
                if (index < 2) {
                  return (
                    <a
                      key={currLink.text}
                      className={`Button Button--small u-marginHoriz2gu u-sm-marginHoriz0 u-sm-block ${
                        currLink.type?.includes('white') && index < 1 ? 'Button--reversed' : ''
                      } ${
                        currLink.type === 'secondary-button'
                          ? 'Button--tertiary'
                          : 'Button--primary'
                      } u-marginTop4gu`}
                      href={`${currLink.href}`}
                      target={`${currLink.target}`}
                      data-analytics={`${currLink.analytics}`}>
                      {currLink.text}
                    </a>
                  )
                }
                return <></>
              })}
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
